/**
 * The pick dialog and the flight it starts are the heavy part of the daily
 * card (album catalog, card art): loaded on intent, never with the page.
 */
export const loadDailyPickDialog = () => import('./DailyPickDialog').then((m) => m.DailyPickDialog);
export const loadJokerPickDialog = () => import('./JokerPickDialog').then((m) => m.JokerPickDialog);
export const loadHubFlightLayer = () =>
  import('./RewardsHubFlightLayer').then((m) => m.RewardsHubFlightLayer);

/** Pointer over the card or focus on it: fetch both chunks before the press. */
export function preloadDailyPick() {
  void loadDailyPickDialog();
  void loadHubFlightLayer();
}
